// Helper function to format creator lists as options for select components
// Filters out shared lists that the user can't edit, and formats as {label, value}
export const formatCreatorListsAsOptions = (lists) => {
  return (lists || [])
    .filter((list) => !list?.isShared || list?.canSharedUsersEdit)
    .map((list) => ({
      label: list.name,
      value: list._id,
    }));
};

